import {Injectable} from '@angular/core';
import {Make} from '../domain/make';
import {MainType} from '../domain/main-type';
import {SubType} from '../domain/sub-type';
import {RestService} from './rest.service';

@Injectable({
    providedIn: 'root'
})
export class LookupService {


    constructor(private restService: RestService) {
    }

    getMakes(filter?: string) {
        let url = '/lookup/makes';
        if (filter) {
            url = url + '?filter=' + filter;
        }
        return this.restService.get<Make[]>(url);
    }

    getMainTypes(makeCode: number, filter?: string) {
        let url = '/lookup/makes/' + makeCode + '/basicType';
        if (filter) {
            url = url + '?filter=' + filter;
        }
        return this.restService.get<MainType[]>(url);
    }

    getSubTypes(makeCode: number, searchSeriesCode: number, filter?: string) {
        let url = '/lookup/makes/' + makeCode + '/' + searchSeriesCode + '/types';
        if (filter) {
            url = url + '?filter=' + filter;
        }
        return this.restService.get<SubType[]>(url);
    }
}
